import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from "@chakra-ui/react";
import theme from './theme';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { PaymentFailurePage, PaymentSuccessPage } from './components/layouts/PaymentSuccessLayout';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
        <ChakraProvider theme={theme}>
            <Routes>
                <Route path="/payment/:paymentId/failure" element={<PaymentFailurePage/>}/>
                <Route path="/payment/:paymentId/success" element={<PaymentSuccessPage/>}/>
                <Route path="*" element={<App/>}/>
            </Routes>
        </ChakraProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
